import React, { useCallback, useEffect, useState } from 'react';
import { useDataProvider } from 'react-admin';
import useNotifyServerError from '../../../core/hooks/useNotifyServerError';
import { Typography } from '@material-ui/core';

const filterChoices = (choices, usedIds) =>
  !usedIds ? choices : choices && choices.filter(ch => !usedIds[ch.id]);

/**
 * Component to block the refresh of the choices received from ReferenceArrayInput
 * @param {*} props
 */
const GridInputChoices = props => {
  const {
    choices = [],
    usedIds,
    emptyText,
    additionalColumns,
    ...rest
  } = props;
  const [extendedChoices, setExtendedChoices] = useState(null);
  const [currentChoices, setCurrentChoices] = useState([]);
  const dataProvider = useDataProvider();
  const notifyServerError = useNotifyServerError();

  const extendWithFamilies = useCallback(
    fundFamilyIds => {
      // Change GET_LIST to getMany so that we can call by chunks to avoid HTT 400: Request header is too large
      dataProvider
        .getMany('fundfamilies', {
          ids: fundFamilyIds,
          target: 'id'
        })
        .then(({ data }) => {
          const familiesDict = data.reduce(
            (obj, item) => ({
              ...obj,
              [item['id']]: item
            }),
            {}
          );

          const choicesWithFamily = choices.map(value => {
            value.fundFamilyName = value.fundFamilyId
              ? familiesDict[value.fundFamilyId].name
              : null;
            return value;
          });
          setExtendedChoices(choicesWithFamily);
        })
        .catch(error => notifyServerError(error, undefined));
    },
    [dataProvider, choices, notifyServerError]
  );

  useEffect(() => {
    if (choices.length > 0 && extendedChoices === null) {
      if (
        additionalColumns &&
        additionalColumns.length > 1 &&
        additionalColumns[1].name === 'fundFamilyName'
      ) {
        setExtendedChoices([]);
        const fundFamilyIds = [
          ...new Set(choices.map(item => item.fundFamilyId))
        ];
        if (fundFamilyIds.length > 0) {
          extendWithFamilies(fundFamilyIds);
        } else {
          additionalColumns.splice(0, 1);
          setExtendedChoices(choices);
        }
      } else {
        setExtendedChoices(choices);
      }
    }
  }, [choices, extendedChoices, additionalColumns, extendWithFamilies]);

  useEffect(() => {
    if (extendedChoices && extendedChoices.length > 0) {
      const newChoices = filterChoices(extendedChoices, usedIds);
      if (
        newChoices.length !== currentChoices.length ||
        newChoices.some((nc, i) => nc !== currentChoices[i])
      ) {
        setCurrentChoices(newChoices);
      }
    }
  }, [extendedChoices, currentChoices, usedIds]);

  if (currentChoices && currentChoices.length) {
    return React.cloneElement(props.children, {
      ...rest,
      choices: currentChoices,
      additionalColumns: additionalColumns
    });
  } else {
    return <Typography>{emptyText}</Typography>;
  }
};

export default GridInputChoices;
